export const ENTITY_ROUTES = {
    EVENT: { path: '/events', hasDetailRoute: true },
    VENDOR: { path: '/vendors', hasDetailRoute: true },
    VENUE: { path: '/venues', hasDetailRoute: true },
    // Edited in a modal on the list page — no per-record route exists.
    EXPENSE: { path: '/expenses', hasDetailRoute: false },
    INQUIRY: { path: '/communications/inquiries', hasDetailRoute: false },
};
/**
 * The in-app path for a record, or `null` when there is nowhere sensible.
 *
 * `null` rather than `'/'` so each caller decides what "nowhere" means: an
 * email button falls back to the front page, and a notification row simply
 * does not navigate.
 */
export function entityPath(entityType, entityId) {
    if (!entityType || !entityId)
        return null;
    const route = ENTITY_ROUTES[entityType.toUpperCase()];
    if (!route)
        return null;
    return route.hasDetailRoute ? `${route.path}/${entityId}` : route.path;
}
//# sourceMappingURL=entityLinks.js.map